import { render } from "./LogHistogramWidget.vue?vue&type=template&id=4eb33dce&scoped=true"
import script from "./LogHistogramWidget.vue?vue&type=script&lang=js"
export * from "./LogHistogramWidget.vue?vue&type=script&lang=js"

import "./LogHistogramWidget.vue?vue&type=style&index=0&id=4eb33dce&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb33dce"]])

export default __exports__